import React, { useState } from 'react';
import { FaDiscord } from 'react-icons/fa';

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true); // Otwórz modal po kliknięciu na ikonę
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Zamknij modal, jeśli użytkownik nie chce przejść
  };

  const handleRedirect = () => {
    window.location.href = 'https://dc.krukshop.ovh'; // Przekierowanie na Discord
  };
  return (
    <footer className="w-full bg-black/50 border-t border-white/10 mt-auto">
      <div className="container mx-auto px-6 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h3 className="text-xl font-bold gradient-text">KrukShop</h3>
            <p className="text-gray-400 text-sm">
              2025 KrukShop. v0.1.3 {/*© Wszelkie prawa zastrzeżone. */}
            </p>
          </div>
          <div className="flex items-center space-x-6">
            <a href="/regulamin" className="text-sm text-gray-300 hover:text-white transition-colors">Regulamin</a>
            <button
              onClick={handleOpenModal}
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="Discord"
            >
              <FaDiscord className="text-2xl" />
            </button>

            {/* Modal */}
            {isModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-black p-6 rounded-lg w-80 max-w-sm">
                  <FaDiscord className="text-4xl mb-4 mx-auto text-blue-500" />
                  <h2 className="text-xl mb-4">Przekierowanie na stronę Discord</h2>
                  <p className="text-white-700 mb-4">
                    Zostaniesz przekierowany na stronę Discord, która nie jest elementem naszego systemu. Kliknij "Przejdź", aby kontynuować.
                  </p>
                  <div className="flex justify-end space-x-4">
                    <button
                      onClick={handleCloseModal}
                      className="px-4 py-2 bg-red-300 hover:bg-red-400 text-black rounded"
                    >
                      Anuluj
                    </button>
                    <button
                      onClick={handleRedirect}
                      className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-black rounded"
                    >
                      Przejdź
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
